export default "__VITE_ASSET__Cmk6Xzhg__"